import React from "react";
import "../styles/teamSection.css";

import valluri from "../asserts/valluri.png";
import murala from "../asserts/murala.png";
import abhinav from "../asserts/abhinav.png";
import lisa from "../asserts/lisa.png";

import kumarstd from "../asserts/kumarstd.png";
import muralastd from "../asserts/muralastd.png";
import abhinavstd from "../asserts/abhinavstd.png";
import lisastd from "../asserts/lisastd.png";

const teamData = [
  {
    image: valluri,
    name: "Valluri Kumar",
    role: "Founder & CEO,CTO",
    desc: "25+ Years of Industry Experience",
    descs: "AI Vision • Solution Architecture",
    desc2: "15+ Years as Chief Architect in Leading MNCs",
    alumniImage: kumarstd,
    imageOnly: true,
  },

  {
    image: murala,
    name: "Subrahmanyam Murala",
    role: "Founder & AI Scientist",
    desc: "Associate Professor &",
    descs: `An internationally recognized AI scientist with over fifteen years of experience, more than 90 research publications, and over 7,000 citations.`,
    alumni: `INDIAN INSTITUTE OF
TECHNOLOGY ROPAR
भारतीय प्रौद्योगिकी संस्थान रोपड़`,

    alumniImage: abhinavstd,
    imageOnly: false,
  },

  {
    image: abhinav,
    name: "Abhinav Dhall",
    role: "Founder & AI Scientist",

    desc: "Associate Professor",

    descs: `International award-winning AI scientist with fifteen years of experience and over 70 research papers with 9000+ citations.`,

    alumni: `Australian National University`,

    alumniImage: muralastd,
    imageOnly: false,
  },

  {
    image: lisa,
    name: "Valluri Lisa",
    role: "Lead Product Designer",

    desc: `Experience working with early-stage startups`,

    descs: `across product design, UI/UX
and Branding`,

    alumni: `SRISHTI INSTITUTE OF
ART, DESIGN & TECHNOLOGY
A Constituent Unit of MAHE, Manipal`,

    alumniImage: lisastd,
    imageOnly: false,
  },
];

const TeamSection = () => {
  return (
    <section className="team-section">
      <h1 className="team-bg-title">The team</h1>

      <div className="team-wrapper">
        {teamData.map((member, index) => (
          <div className="team-card" key={index}>
            {/* TOP 70% */}
            <div className="team-inner">
              <img
                src={member.image}
                alt={member.name}
                className="team-image"
              />

              <h3>{member.name}</h3>

              <h4>{member.role}</h4>

              <p>{member.desc}</p>

              {member.descs && <p>{member.descs}</p>}

              {member.desc2 && <p>{member.desc2}</p>}
            </div>

            {/* BOTTOM 30% */}
            <div className="alumni-box">
              <span>
                {index === 2 ? "PhD, Computer Science from :" : "Alumni of :"}
              </span>

              {member.imageOnly ? (
                <img
                  src={member.alumniImage}
                  alt=""
                  className={`full-alumni-img ${index === 1 ? "murala-logo" : ""}`}
                />
              ) : (
                <div className="bottom-sec">
                  <img
                    src={member.alumniImage}
                    alt=""
                    className="alumni-image"
                  />

                  <h5>{member.alumni}</h5>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
